import React, { FC } from 'react';
import { Flex, Text, Link } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useTranslation, Trans } from 'react-i18next';
import styled from '@emotion/styled/macro';
import { ReactComponent as Oops } from 'assets/svgs/Oops.svg';
import { Button } from 'components';
import { rem } from 'utils/fonts';

interface Props {
  errorViewBtnCallback: () => void;
  errorViewBtnLabel?: string;
  errorText?: string;
  errorType?: string;
}

const StyledOops = styled(Oops)`
  align-self: center;
  max-width: 160px;
`;

const Wrapper = styled(Flex)`
  flex-direction: column;
  flex: 1;
  padding: 0 20px;
`;

const StyledLink = styled(Link)`
  font-weight: bold;
  text-decoration: underline;
`;

const ErrorView: FC<Props> = ({ errorViewBtnCallback, errorType, errorViewBtnLabel, errorText }) => {
  const { t } = useTranslation('common');
  const errorViewBtnLabelTranslated = errorViewBtnLabel || t('error.btnLabel');
  const errorTextTranslated = errorText || t('error.explanation');

  return (
    <Wrapper>
      <Flex flex="1" w="100%" justifyContent="center" alignItems="center">
        <Flex flexDirection="column" sx={{ '& path': { fill: 'other.CTA' } }}>
          <StyledOops />
          <Flex mt="60px" direction="column" alignItems="center">
            <Text fontWeight={600} fontSize={rem(19)} color="other.CTA" mb="5px" textAlign="center">
              {t('error.title')}
            </Text>
            {errorType !== 'country' && (
              <Text mt="6px" fontSize={rem(15)} textAlign="center">
                {errorTextTranslated}
              </Text>
            )}
            <Text fontSize={rem(15)} textAlign="center">
              {errorType === 'country' ? (
                <Trans t={t} i18nKey="error.countryProblem">
                  This country is not set up yet, but{' '}
                  <StyledLink href="mailto:support@chooose.today" target="_blank" rel="noopener noreferrer" color="other.CTA">
                    get in touch with us
                  </StyledLink>{' '}
                  and we will make your wish come true.
                </Trans>
              ) : (
                <Trans t={t} i18nKey="error.details">
                  If the problem persists, you can{' '}
                  <StyledLink href="mailto:support@chooose.today" target="_blank" rel="noopener noreferrer" color="other.CTA">
                    contact
                  </StyledLink>{' '}
                  CHOOOSE.
                </Trans>
              )}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Button
        fontWeight={500}
        fontSize={rem(14)}
        color="secondary.800"
        alignSelf="center"
        mt="40px"
        colorScheme="gray"
        variant="ghost"
        leftIcon={<ArrowBackIcon />}
        onClick={errorViewBtnCallback}
      >
        <span>{errorViewBtnLabelTranslated}</span>
      </Button>
    </Wrapper>
  );
};

export default ErrorView;
